// Deterministic pseudo-ratings so each product shows a stable, believable rating
// (not identical 4.9 everywhere). Seeded by the product handle/id so the same
// product always renders the same rating + review count across reloads.

const hash = (str) => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h);
};

// Weighted buckets so most products land in the 4.6 – 4.9 range,
// a few at 5.0, a couple lower at 4.4 / 4.5.
const RATING_BUCKETS = [
  { r: 4.4, w: 2 },
  { r: 4.5, w: 4 },
  { r: 4.6, w: 10 },
  { r: 4.7, w: 20 },
  { r: 4.8, w: 28 },
  { r: 4.9, w: 24 },
  { r: 5.0, w: 12 },
];
const TOTAL_W = RATING_BUCKETS.reduce((s, b) => s + b.w, 0);

export const ratingFor = (seed) => {
  if (!seed) return 4.8;
  let pick = hash(String(seed)) % TOTAL_W;
  for (const b of RATING_BUCKETS) {
    if (pick < b.w) return b.r;
    pick -= b.w;
  }
  return 4.8;
};

export const reviewCountFor = (seed) => {
  if (!seed) return 48;
  // 24 – 420 range, varied per handle
  return 24 + (hash(String(seed) + "r") % 397);
};
